import React from "react";
import './info.scss';
import Loading from "../Loading/loading";
import { useHistory } from 'react-router-dom';


export default function Info(props) {
    const history = useHistory();

    const {loading, professionalsLength} = props;

    if(loading) return <Loading/>

    return (
            <div className={'info-container'} >
                <div className={'info-page-header'}>
                    <a onClick={()=>history.push('/')} href={'#'}>המקצוענים של מערבא</a>
                    {' > '}
                    אודות האפליקצייה
                </div>
                <div className={'info-text'}>
                    מי אנחנו?
                    <br/>
                    ״המקצוענים של מערבא״ הינה יוזמה מקומית של קהילת העסקים מערבא.
                    תכנון ותחזוק האפליקציה נעשה בהתנדבות, במטרה לעודד צריכה מקומית  ולהנגיש לתושבים את המידע על העסקים המקומיים.
                    <br/><br/>

                    החזון שלנו:
                    <br/>
                    אנחנו מאמינים בכח של קהילה לחבור יחד ולפעול למען הצרכים שלה. בשנים האחרונות קמה קבוצת אשכול העסקים מערבא. הקבוצה כוללת פעילות בוואצאפ ומפגשי נטוורקינג עם הרצאות אחת לחודש.

                    אחד הצרכים המרכזיים שעלו בקבוצה ומצד התושבים זה הצורך להנגיש את העסקים המקומיים לקהילת התושבים בגוש מערבא.
                    בהתאם, כל בעל עסק מהישובים ברוכין, לשם, עלי זהב ופדואל יכול להופיע באופן שווה וללא תשלום במאגר המידע ״המקצוענים של מערבא״.
                    <br/>
                    <b>יחד אנחנו קהילה חזקה יותר!</b>

                    <br/><br/>

                    <div className={'info-text'}>
                        עד כה הצטרפו למאגר {professionalsLength} בעלי עסקים שונים בגוש מערבא.
                    </div>

                    <br/><br/>

                    צוות תכנון האפליקציה:
                    <br/>
                    יהודה לבנוני:  בניה ותחזוקת האפליקצייה, תושב לשם.
                    <br/>
                    <a onClick={()=>history.push('/sindi-g-r')} href={'#'}>סינדי  רימון</a>
                    :בעלת 2 תארים בחשבונאות וכלכלה, תכנון ותפעול מאגר הנתונים, תושבת עלי זהב, בעלת עסק לשירותי חשבונאות ומיסים.
                    <br/>
                    <a onClick={()=>history.push('/asl-serv')} href={'#'}>אריה שוחט</a>
                    : חשמלאי מהנדס, תכנון ותפעול מאגר הנתונים, תושב עלי זהב, בעל עסק לשירותי תיקונים למוצרי חשמל ביתיים.
                    <br/>
                    <a onClick={()=>history.push('/orit-nagar')} href={'#'}>אורית נגר</a>
                    : בעלת תואר ראשון בעבודה סוציאלית קהילתית, מובילת אשכול העסקים מערבא, תושבת לשם. בעלת עסק לאיפור ושיער לכלות.
                    <br/>
                </div>
            </div>

    );
}